import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { routes } from './app/app.routes';
import { STORAGE_CONFIG } from './app/services/storage.config';
import { AppRouteReuseStrategy } from './app/services/app-route-reuse.strategy';
import { provideHttpClient } from '@angular/common/http';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    AppRouteReuseStrategy,
    { provide: RouteReuseStrategy, useExisting: AppRouteReuseStrategy },
    provideIonicAngular(),
    provideRouter(routes),
    provideHttpClient(),
    ...STORAGE_CONFIG
  ],
});
